import {
  Box,
  Button,
  CircularProgress,
  CircularProgressLabel,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react"

import greenArrowIcon from "#/assets/arrow-green.svg"
import DepositModalDivider from "#/ui-old/Deposit/DepositModal/DepositModalDivider"

export default function DepositMigrationSuccessModal({
  onClose,
}: {
  onClose: () => void
}) {
  return (
    <Box bg="primary.white.100" borderRadius="1.5rem" w="522px" p="3rem 4rem">
      <VStack>
        <CircularProgress
          size="140px"
          thickness="4px"
          color="green.highlight"
          trackColor="primary.white.100"
          isIndeterminate
        >
          <CircularProgressLabel
            display="flex"
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Image src={greenArrowIcon} w="88px" h="88px" />
          </CircularProgressLabel>
        </CircularProgress>
        <Text
          variant="body"
          color="green.highlight"
          fontWeight={500}
          fontFamily="riforma.medium"
          lineHeight={0}
          fontSize="2rem"
          mt={1}
        >
          Migration started...
        </Text>
        <DepositModalDivider />
        <Text
          variant="body"
          fontWeight={500}
          fontFamily="riforma.medium"
          color="#0D1014"
        >
          You can{" "}
          <Button
            display="inline"
            variant="unstyled"
            onClick={onClose}
            fontWeight={500}
            textDecor="underline"
          >
            close
          </Button>{" "}
          this window now.
        </Text>
      </VStack>
    </Box>
  )
}
